import { render } from "./usr_acc.vue?vue&type=template&id=c60b6492&scoped=true"
import script from "./usr_acc.vue?vue&type=script&lang=js"
export * from "./usr_acc.vue?vue&type=script&lang=js"

import "./usr_acc.vue?vue&type=style&index=0&id=c60b6492&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60b6492"]])

export default __exports__